/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

export function isAnalyticsRequest(url: string): boolean {
  return url.includes('telemetry');
}
